import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { TipoInsucessoService } from './tipo-insucesso-service/tipo-insucesso.service';

@Component({
  selector: 'app-tipo-insucessos',
  templateUrl: './tipo-insucessos.component.html',
  styleUrls: ['./tipo-insucessos.component.scss']
})
export class TipoInsucessosComponent implements OnInit {

  display: boolean = false;
  carregando = true;
  tipoInsucesso: any[] = [];
  nomeNovoTipoEvento: string = '';

  tipoInsucessoParaExcluir: any = null;
  displayConfirmarExclusao: boolean = false;

  displayVinculos: boolean = false;
  carregandoVinculos: boolean = false;
  tipoInsucessoSelecionado: any = null;
  elementosDisponiveis: any[] = [];
  elementosVinculados: any[] = [];
  elementosDisponiveisFiltrados: any[] = [];
  elementosVinculadosFiltrados: any[] = [];
  alteracoesVinculos: boolean = false;
  termoPesquisaDisponiveis: string = '';
  termoPesquisaVinculados: string = '';

  constructor(
    private serviceTipoInsucesso: TipoInsucessoService,
    private translate: TranslateService,
    private router: Router,
    private toastr: ToastrService) { }

  ngOnInit() {
    this.carregando = true;
    this.carregarTipoInsucesso();
  }

  adicionarTipoInsucesso(nomeTipoInsucesso: string) {
    if (!nomeTipoInsucesso || nomeTipoInsucesso.trim() === '') {
      this.exibirErro(this.translate.instant('parametros.tipoInsucesso.nomeObrigatorio'), this.translate.instant('parametros.tipoInsucesso.erro'));
      return;
    }

    // Verificar se já existe um tipo de evento com este nome
    const tipoInsucessoExistente = this.tipoInsucesso.find(f =>
      f.nome.toLowerCase() === nomeTipoInsucesso.toLowerCase()
    );

    if (tipoInsucessoExistente) {
      this.exibirErro(this.translate.instant('parametros.tipoInsucesso.tipoInsucessoJaExiste'), this.translate.instant('parametros.tipoInsucesso.erro'));
      return;
    }

    this.serviceTipoInsucesso.adicionarTipoInsucessos(nomeTipoInsucesso.trim()).then((response: any) => {
      this.exibirSucesso(
        this.translate.instant('parametros.tipoInsucesso.tipoInsucessoAdicionado'),
        this.translate.instant('parametros.tipoInsucesso.sucesso')
      );
      this.nomeNovoTipoEvento = '';
      this.display = false;
      this.carregarTipoInsucesso();
    })
  }

  carregarTipoInsucesso() {
    this.carregando = true;
    this.tipoInsucesso = [];

    this.serviceTipoInsucesso.getTipoInsucessos().then((response: any) => {

      const dadosTipoInsucessos = Array.isArray(response?.data) ? response.data : response;

      if (dadosTipoInsucessos && Array.isArray(dadosTipoInsucessos)) {
        this.tipoInsucesso = dadosTipoInsucessos.map((tipoInsucesso: any) => ({
          id: tipoInsucesso.idPadraoTipoInsucesso ?? tipoInsucesso.id,
          nome: tipoInsucesso.descInsucessoFab ?? tipoInsucesso.descTipoEvento ?? tipoInsucesso.nome,
          vinculos: tipoInsucesso.countInsucessos ?? tipoInsucesso.vinculos ?? 0
        }));
      }
      this.carregando = false;

    }).catch((error: any) => {
      this.carregando = false;
      console.error('Erro ao carregar tipo insucessos:', error);
      this.tratarErro(
        this.translate.instant('parametros.tipoInsucesso.erroCarregarTipoInsucesso'),
        this.translate.instant('parametros.tipoInsucesso.erro'),
        error
      );
    });
  }

  removerTipoInsucesso(idTipoInsucesso: number) {
    const index = this.tipoInsucesso.findIndex(f => f.id === idTipoInsucesso);
    if (index > -1) {
      const tipoInsucessoRemovido = this.tipoInsucesso[index];

      // Verificar se há vínculos ativos
      if (tipoInsucessoRemovido.vinculos > 0) {
        const mensagem = this.translate.instant('parametros.tipoInsucesso.naoPodeRemoverComVinculos')
          .replace('{nome}', tipoInsucessoRemovido.nome)
          .replace('{vinculos}', tipoInsucessoRemovido.vinculos.toString());
        this.exibirErro(mensagem, this.translate.instant('parametros.tipoInsucesso.avisoVinculosAtivos'));
        return;
      }

      // Mostrar modal de confirmação
      this.tipoInsucessoParaExcluir = tipoInsucessoRemovido;
      this.displayConfirmarExclusao = true;
    }
  }

  confirmarExclusao() {
    if (!this.tipoInsucessoParaExcluir) return;

    // Chamada para o backend para remover o tipo de insucesso
    this.serviceTipoInsucesso.removerTipoInsucessos(this.tipoInsucessoParaExcluir.id).then((response: any) => {
      this.exibirSucesso(
        this.translate.instant('parametros.tipoInsucesso.tipoInsucessoRemovido'),
        this.translate.instant('parametros.tipoInsucesso.sucesso')
      );
      this.hideDialogConfirmarExclusao();

      // Recarregar a lista de tipos de insucesso após remover
      this.carregarTipoInsucesso();
    })
      .catch((error: any) => {
        this.tratarErro(
          this.translate.instant('parametros.tipoInsucesso.erroRemoverTipoInsucesso'),
          this.translate.instant('parametros.tipoInsucesso.erro'),
          error
        );
      });
  }

  hideDialogConfirmarExclusao() {
    this.displayConfirmarExclusao = false;
    this.tipoInsucessoParaExcluir = null;
  }

  exibirErro(mensagem: string, titulo: string) {
    this.toastr.error(mensagem, titulo, {
      positionClass: 'toast-bottom-right',
      timeOut: 3000,
      progressBar: true,
      closeButton: true
    });
  }

  exibirSucesso(mensagem: string, titulo: string) {
    this.toastr.success(mensagem, titulo, {
      positionClass: 'toast-bottom-right',
      timeOut: 3000,
      progressBar: true,
      closeButton: true
    });
  }

  tratarErro(mensagem: string, titulo: string, error: any) {
    this.carregando = false;
    let msg: string;
    try {
      if (error.status === 401) {
        this.router.navigateByUrl('logout');
      }
      msg = mensagem + '\n' + error.erro;
    } catch (Exception) {
      msg = mensagem;
    }
    this.toastr.error(msg, titulo, {
      positionClass: 'toast-bottom-right',
      timeOut: 3000,
      progressBar: true,
      closeButton: true
    });
  }

  verVinculos(tipoInsucesso: any) {
    this.tipoInsucessoSelecionado = tipoInsucesso;
    this.elementosDisponiveis = [];
    this.elementosVinculados = [];
    this.elementosDisponiveisFiltrados = [];
    this.elementosVinculadosFiltrados = [];
    this.termoPesquisaDisponiveis = '';
    this.termoPesquisaVinculados = '';
    this.alteracoesVinculos = false;
    this.carregandoVinculos = true;
    this.displayVinculos = true;

    this.carregarElementosVinculos(tipoInsucesso.id);
  }

  carregarElementosVinculos(tipoInsucessoId: number) {
    this.serviceTipoInsucesso.getVinculosTipoInsucessos(tipoInsucessoId).then((response: any) => {
      let dadosVinculos = response;

      if (response && response.data) {
        dadosVinculos = response.data;
      }

      if (!dadosVinculos) {
        dadosVinculos = {
          disponiveis: [],
          vinculados: []
        };
      }

      this.processarVinculosTipoInsucesso(dadosVinculos);
      this.carregandoVinculos = false;
    })
      .catch((error: any) => {
        console.error('Erro ao carregar vínculos:', error);
        this.carregandoVinculos = false;
        this.tratarErro(
          this.translate.instant('parametros.tipoInsucesso.erroCarregarVinculos'),
          this.translate.instant('parametros.tipoInsucesso.erro'),
          error
        );
      });
  }

  private processarVinculosTipoInsucesso(dadosVinculos: any) {

    this.elementosDisponiveis = (dadosVinculos.disponiveis || []).map((item: any, index: number) => ({
      id: `disp_${index}`,
      nome: item.descTipoInsucesso,
      vinculado: false
    }));

    this.elementosVinculados = (dadosVinculos.vinculados || []).map((item: any, index: number) => ({
      id: `vinc_${index}`,
      nome: item.descTipoInsucesso,
      vinculado: true
    }));

    this.elementosDisponiveisFiltrados = [...this.elementosDisponiveis];
    this.elementosVinculadosFiltrados = [...this.elementosVinculados];
    this.termoPesquisaDisponiveis = '';
    this.termoPesquisaVinculados = '';
    this.alteracoesVinculos = false;
  }

  vincularTodosFiltrados() {
    if (this.elementosDisponiveisFiltrados.length === 0) return;
    const elementosParaVincular = [...this.elementosDisponiveisFiltrados];

    elementosParaVincular.forEach(elemento => {
      if (!elemento.vinculado) {
        const index = this.elementosDisponiveis.findIndex(e => e.id === elemento.id);
        if (index > -1) {
          this.elementosDisponiveis.splice(index, 1);
        }

        elemento.vinculado = true;
        this.elementosVinculados.push(elemento);
      }
    });

    this.filtrarElementosDisponiveis();
    this.filtrarElementosVinculados();
    this.alteracoesVinculos = true;
  }

  removerVinculo(elemento: any) {
    const index = this.elementosVinculados.findIndex(e => e.id === elemento.id);
    if (index > -1) {
      this.elementosVinculados.splice(index, 1);
    }

    elemento.vinculado = false;
    this.elementosDisponiveis.push(elemento);
    this.filtrarElementosDisponiveis();
    this.filtrarElementosVinculados();
    this.alteracoesVinculos = true;
  }

  removerTodosVinculos() {
    if (this.elementosVinculados.length === 0) return;

    // Remover todos os vínculos
    this.elementosVinculados.forEach(elemento => {
      elemento.vinculado = false;
      this.elementosDisponiveis.push(elemento);
    });

    this.elementosVinculados = [];
    this.filtrarElementosDisponiveis();
    this.filtrarElementosVinculados();
    this.alteracoesVinculos = true;
  }

  filtrarElementosDisponiveis() {
    if (!this.termoPesquisaDisponiveis || this.termoPesquisaDisponiveis.trim() === '') {
      this.elementosDisponiveisFiltrados = [...this.elementosDisponiveis];
    } else {
      const termo = this.termoPesquisaDisponiveis.toLowerCase().trim();
      this.elementosDisponiveisFiltrados = this.elementosDisponiveis.filter(elemento =>
        elemento.nome.toLowerCase().includes(termo) ||
        (elemento.criadoPor && elemento.criadoPor.toLowerCase().includes(termo))
      );
    }
  }

  filtrarElementosVinculados() {
    if (!this.termoPesquisaVinculados || this.termoPesquisaVinculados.trim() === '') {
      this.elementosVinculadosFiltrados = [...this.elementosVinculados];
    } else {
      const termo = this.termoPesquisaVinculados.toLowerCase().trim();
      this.elementosVinculadosFiltrados = this.elementosVinculados.filter(elemento =>
        elemento.nome.toLowerCase().includes(termo) ||
        (elemento.criadoPor && elemento.criadoPor.toLowerCase().includes(termo))
      );
    }
  }

  hideDialogVinculos() {
    this.displayVinculos = false;
    this.carregandoVinculos = false;
    this.tipoInsucessoSelecionado = null;
    this.elementosDisponiveis = [];
    this.elementosVinculados = [];
    this.elementosDisponiveisFiltrados = [];
    this.elementosVinculadosFiltrados = [];
    this.termoPesquisaDisponiveis = '';
    this.termoPesquisaVinculados = '';
    this.alteracoesVinculos = false;
  }

  // TrackBy function para otimizar performance
  trackByElemento(index: number, elemento: any): number {
    return elemento.id;
  }

  limparPesquisaDisponiveis() {
    this.termoPesquisaDisponiveis = '';
    this.filtrarElementosDisponiveis();
  }

  limparPesquisaVinculados() {
    this.termoPesquisaVinculados = '';
    this.filtrarElementosVinculados();
  }

  adicionarVinculo(elemento: any) {
    if (elemento.vinculado) return;

    const index = this.elementosDisponiveis.findIndex(e => e.id === elemento.id);
    if (index > -1) {
      this.elementosDisponiveis.splice(index, 1);
    }

    elemento.vinculado = true;
    this.elementosVinculados.push(elemento);
    this.filtrarElementosDisponiveis();
    this.filtrarElementosVinculados();
    this.alteracoesVinculos = true;
  }

  salvarVinculos() {
    if (!this.alteracoesVinculos) return;

    this.serviceTipoInsucesso.salvarVinculosTipoInsucessos(this.tipoInsucessoSelecionado.id, this.elementosVinculados).then((response: any) => {
      this.tipoInsucessoSelecionado.vinculos = this.elementosVinculados.length;
      const tipoInsucessoIndex = this.tipoInsucesso.findIndex(f => f.id === this.tipoInsucessoSelecionado.id);

      if (tipoInsucessoIndex > -1) {
        this.tipoInsucesso[tipoInsucessoIndex].vinculos = this.elementosVinculados.length;
      }

      this.exibirSucesso(
        this.translate.instant('parametros.tipoInsucesso.vinculosSalvos'),
        this.translate.instant('parametros.tipoInsucesso.sucesso')
      );
      this.alteracoesVinculos = false;
      this.hideDialogVinculos();
    })
      .catch((error: any) => {
        this.tratarErro(
          this.translate.instant('parametros.tipoInsucesso.erroSalvarVinculos'),
          this.translate.instant('parametros.tipoInsucesso.erro'),
          error
        );
      });
  }
}
